import { Grid, Typography } from '@mui/material'
import React from 'react'

function Blog() {
    return (
        <>
        <title>Blog</title>
         <Grid container className="section" style={{paddingBottom:"30px",marginTop:"30px",overflow:"hidden"}} spacing={5}>

           <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold"}}>Backend related blog</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>1)jwt:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                   JWT is mainly used for authorization purposes.But the main purpose of JWT was to allow the two parties to communicate securely in a standard way.JSON Web Token  is an open standard that defines a compact and URL-safe way to securely transmit information as a JSON object between parties. A JWT is often used to secure RESTful APIs because it can be used to authenticate a client that wants to access the APIs
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>2)Mysql:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                    MySQL is an open-source relational database management system .Its name is a combination of "My" the name of co-founder Michael Widenius's daughter,and "SQL", the full meaning is Structured Query Language. A relational database organizes data into one or more data tables in which data types may be related to each other; these relations help structure the data. SQL is a language programmers use to create, modify and extract data from the relational database, as well as control user access to the database.
                </Typography>
            </Grid>
            
            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>3)sql and nosql database difference:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                    MySQL is a relational database that is based on tabular design where as NoSQL is non-relational in nature with its document-based design. MySQL has established a database, covering huge IT market whereas NoSQL databases are the latest arrival, hence still gaining popularity among big IT giants.sql language is vertical scable and nosql is horizontally scable.but two databases has some advantage and disadvantage. Which is better it depends on your project.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>4)Expressjs:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                  Express is a backend web application framework for Node.js, that provides a robust set of features for web and mobile applications.Node. js is a platform for building the i/o applications which are server-side event-driven and made using JavaScript. Express. js is a framework based on Node.Expressjs  used for designing and building web applications quickly and easily.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>5)Mongoose:- </Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                Mongoose is an Object Data Modeling (ODM) library for MongoDB and Node.js. It manages relationships between data, provides schema validation, and is used to translate between objects in code and the representation of those objects in MongoDB.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>6)crudoperation:- </Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                  crud full meaning is create,read,update,delete.these are the basic operation of storage management.they are the backbone for interacting with any database.If you’ve ever worked with a database, you’ve likely worked with CRUD operations.Most applications have some form of CRUD functionality. In fact, every programmer has had to deal with CRUD at some point. Not to mention, a CRUD application is one that utilizes forms to retrieve and return data from a database.
                </Typography>
            </Grid>

            





           <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold"}}>Blog for Reactjs</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>1)jsx:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                     jsx full meaning is javascript xml.jsx allows to write html in react.JSX makes it easier to write and add html in react.JSX converts HTML tags into react elements.JSX is an extension of the JavaScript language based on ES6, and is translated into regular JavaScript at runtime.
                    Example:-
                </Typography>
                <img src="https://i.postimg.cc/fyb9yr23/reactpic111111.png"/>
                 
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>2)React diff algorithm:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                  React uses virtual DOM to enhance its performance. It uses the observable to detect state and prop changes. React uses an efficient diff algorithm to compare the versions of virtual DOM. It then makes sure that batched updates are sent to the real DOM for repainting or re-rendering of the UI. if you explain easily then you can say When new elements are added to the UI, a virtual DOM, which is represented as a tree is created. Each element is a node on this tree. If the state of any of these elements changes, a new virtual DOM tree is created. This tree is then compared or “diffed” with the previous virtual DOM tree. Once this is done, the virtual DOM calculates the best possible method to make these changes to the real DOM. This ensures that there are minimal operations on the real DOM. Hence, reducing the performance cost of updating the real DOM.
                </Typography>
                
                 
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>3)Context api:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                  The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to prop drilling or moving props from grandparent to child to parent, and so on.React Context is a method to pass props from parent to child component(s), by storing the props in a store and using these props from the store by child component without actually passing them manually at each level of the component tree.
                </Typography>
                
                 
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>4)component lifecycle:-</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>
                Lifecycle methods are special methods built-in to React, used to operate on components throughout their duration in the DOM. you can think of the React component lifecycle as the lifetime of a component. React Lifecycle methods are series of events that happen throughout Mounting updating unmounting like birth growth and death. Each component in React has a lifecycle which you can monitor and manipulate during its three main phases. The three phases are: Mounting, Updating, and Unmounting.
                </Typography>
                
                 
            </Grid>
  
      {/* react blog end */}








            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold"}}>Blog for css</Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>1)::before and ::after</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>css ::before and ::after is a pseudo element.we can use them to insert before or after the content of an element.it is very help full for this type of work. I have given an example
                 For this:-
                </Typography>

                 <img  src="https://i.postimg.cc/jj5zSjmk/photocss1.png"/>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>2)transform</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>transform is a one of the most popular properties in css.transform has 4 elements.those are skew,rotate,translate, scale.if you need to rotate anything you can use rotate element. if you need to move any thing horizontally or vertically then you can use translate element. if you want to make something smaller or bigger then you can use scale element.if you want to make flattened anything then you can use skew element.
                </Typography>

                 <img  src="https://i.postimg.cc/pT5zK62f/photocss3.png"/>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>3)specificity</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>what is specificity.many people dont know what is specificity.specificity means by which browser decide which css properties value is most relevant to an element and then it will be applied on this element. That is specificity.
                </Typography>

                 <img  src="https://i.postimg.cc/0jgmn0QL/photocss4.png"/>
            </Grid>


            <Grid item xs={12}>
                <Typography variant="h5" style={{fontWeight:"bold",color:"red"}}>4)media query</Typography><br/>
                <Typography style={{marginLeft:"20px"}}>media query is a popular technic for  responsive your website.Media queries allow you to customize the presentation of your web pages for a specific range of devices like mobile phones, tablets, desktops, etc. without any change in markups.
 
                Media query used can be check many thing like:-
 
                1.width and height of the view port.
                2.width and height of the device.
                3.resolution.
 
                </Typography>

                 <img  src="https://i.postimg.cc/vmN5gsd8/photocss5.png"/>
            </Grid>
         </Grid>
           
        </>
    )
}

export default Blog
